// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"g_-z","disabled":"h_-z","label":"i_-z"};